import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofVideoTutorialPage } from './proof-video-tutorial';

import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ProofVideoTutorialPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofVideoTutorialPage),
    PipesModule,
  ],
  exports: [
    ProofVideoTutorialPage
  ]
})
export class ProofVideoTutorialPageModule { }



// WEBPACK FOOTER //
// ./src/pages/proof-video-tutorial/proof-video-tutorial.module.ts